import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout } from '../../store/slices/authSlice';

const getRoleLabel = (role) => {
  const labels = {
    admin: 'Admin',
    operator: 'Operator',
    viewer: 'Viewer',
    warehouse: 'Magazijn'
  };
  return labels[role] || role;
};

const getRoleBadgeColor = (role) => {
  const colors = {
    admin: 'dark',
    operator: 'light',
    viewer: 'secondary',
    warehouse: 'info'
  };
  return colors[role] || 'secondary';
};

const Navbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-dark fixed-top px-3">
      <a className="navbar-brand d-flex align-items-center" href="/">
        <img
          src="/logo.svg"
          alt="Tafelzeil Online"
          height="28"
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </a>
      <div className="d-flex align-items-center">
        <span className="text-white-50 me-3 small">
          <i className="bi bi-person-circle me-1"></i>
          {user?.name || 'Gebruiker'}
          {user?.role && (
            <span className={`badge ms-2 bg-${getRoleBadgeColor(user.role)}`}>
              {getRoleLabel(user.role)}
            </span>
          )}
        </span>
        <button onClick={handleLogout} className="btn btn-sm btn-outline-light">
          <i className="bi bi-box-arrow-right me-1"></i>
          Uitloggen
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
